import * as React from "react";
import {InfoTooltip} from "../InfoTooltip";

type UserAgreementProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
}

export const UserAgreement: React.FC<UserAgreementProps> = ({
    isOpen,
    onClose,
    onConfirm
}) => {
    return (
        <InfoTooltip isOpen={isOpen} onClose={onClose} width='wide'>
            <h1 className='form__header'>Пользовательское соглашение</h1>
            <p className='text'>Добрый день, уважаемые друзья и коллеги!</p>
            <p className='text'>
                Впереди Чемпионат мира 2026, к сожалению, без участия команды из России,
                который пройдёт с 11 июня 2026 г. – 19 июля 2026 г.
            </p>
            <p className='text'>
                Предлагаю испытать свою удачу, проверить шестое чувство
                и аналитические прогностические способности!
            </p>

            <p className='text' style={{ fontWeight: 600, marginTop: 16, marginBottom: 16, padding: '10px 14px', border: '1px solid #f0b400', borderRadius: 6 }}>
                ⚠️ Изменения от 19.06.2026:<br />
                • Максимальная обычная ставка — <strong>10 баллов</strong> за матч.<br />
                • Ва-банк доступен <strong>один раз за раунд</strong> и только если нет других активных ставок.
                • Все ранее заработанные баллы и сделанные ставки <strong>сохраняются</strong> без изменений.
            </p>

            <p className='text'><strong>Условия регистрации на сайте:</strong></p>
            <ul className='text'>
                <li>Вводим почту (любую, но только ту, на которую сможете зайти), придумываем пароль (не забываем).</li>
                <li>Обязательно придумываем никнейм (по имени не регистрируемся).</li>
            </ul>

            <p className='text'><strong>Условия соревнования:</strong></p>
            <ol className='text'>
                <li>Участвовать только по «позывному».</li>
                <li>Прогноз заполняется заблаговременно, менять можно до начала матча.</li>
                <li>На каждый матч указывается точный счёт.</li>
                <li>Сетка плей-офф заполняется по результатам группового этапа.</li>
                <li>В плей-офф при ничьей можно указать счёт доп. времени и серии пенальти.</li>
            </ol>

            <p className='text'><strong>Баллы за прогноз:</strong></p>
            <ul className='text'>
                <li>Угадан исход матча (победитель или ничья) — <strong>1 балл</strong></li>
                <li>Угадана разница мячей — <strong>2 балла</strong></li>
                <li>Угадан точный счёт — <strong>3 балла</strong></li>
            </ul>
            <p className='text' style={{ fontSize: '0.85rem' }}>
                Баллы не суммируются: если угадан точный счёт — начисляется 3 балла.
            </p>

            <p className='text'><strong>Плей-офф (при ничьей):</strong></p>
            <ul className='text'>
                <li>Угадан победитель в доп. время или по пенальти — <strong>1 балл</strong></li>
                <li>Угадан точный счёт доп. времени или пенальти — <strong>3 балла</strong></li>
            </ul>
            <p className='text'>
                Максимум за матч с пенальти — <strong>9 баллов</strong> (по 3 за основное время,
                доп. время и серию пенальти).
            </p>

            <p className='text'><strong>Турнирный прогноз:</strong></p>
            <ul className='text'>
                <li>До начала первой игры плей-офф нужно выбрать, какие команды пройдут в каждую стадию.</li>
                <li>Начинаешь с 1/16 финала — выбираешь 16 команд из всех участников.</li>
                <li>На следующих стадиях выбираешь только из ранее отобранных команд.</li>
                <li>В полуфинале выбираешь 2 победителей — они идут в финал, оставшиеся 2 — в матч за 3-е место.</li>
                <li>В финале и матче за 3-е место выбираешь по одному победителю.</li>
            </ul>

            <p className='text'><strong>Баллы за турнирный прогноз:</strong></p>
            <ul className='text'>
                <li>Команда реально дошла до указанной стадии — <strong>+1 балл</strong></li>
                <li>Угадано 3-е место (победитель матча за 3-е место) — <strong>+5 баллов</strong></li>
                <li>Угадан чемпион мира (победитель финала) — <strong>+10 баллов</strong></li>
            </ul>

            <p className='text'><strong>Ставки баллами:</strong></p>
            <ul className='text'>
                <li>На любой матч можно поставить часть своих доступных баллов на собственный прогноз.</li>
                <li>Если прогноз сбывается — ставка возвращается с умножением на коэффициент.</li>
                <li>Если прогноз не сбылся — ставка сгорает.</li>
                <li>Ставку можно делать на каждый матч, но нельзя превысить доступный баланс.</li>
            </ul>

            <p className='text'><strong>Коэффициенты ставок:</strong></p>
            <ul className='text'>
                <li>Угадан исход — <strong>×1.5</strong></li>
                <li>Угадана разница — <strong>×2</strong></li>
                <li>Угадан точный счёт — <strong>×4</strong></li>
                <li>Угадан точный счёт + пенальти — <strong>×6</strong></li>
            </ul>

            <p className='text'><strong>Ва-банк:</strong></p>
            <p className='text'>
                Если игрок ставит все доступные баллы на один матч — это автоматически считается
                ва-банком. Коэффициент ставки дополнительно умножается на <strong>1.5</strong>.
                При проигрыше баланс обнуляется. Снова ставить можно будет только после
                заработка баллов на других прогнозах.
            </p>

            <p className='text'><strong>Золотой джокер:</strong></p>
            <p className='text'>
                Один раз за турнир можно активировать золотой джокер для любого тура группового этапа
                или стадии плей-офф. Все баллы за прогнозы в этом туре/раунде
                <strong> удваиваются</strong>.
            </p>

            <p className='text'><strong>Покупка баллов:</strong></p>
            <p className='text'>
                Можно приобрести дополнительные баллы для ставок.
                Одна покупка — <strong>+10 баллов</strong>.
            </p>
            <p className='text' style={{ fontSize: '0.85rem' }}>
                ⚠️ Купленные баллы <strong>не учитываются в рейтинге</strong>.
                Они доступны только для ставок. Заработанные с их помощью баллы (выигрыши со ставок)
                попадают в рейтинг на общих основаниях.
            </p>

            <p className='text'><strong>Победители:</strong></p>
            <ul className='text'>
                <li>🥇 1-е место — 50% от банка</li>
                <li>🥈 2-е место — 30% от банка</li>
                <li>🥉 3-е место — 20% от банка</li>
            </ul>
            <p className='text' style={{ fontSize: '0.85rem' }}>
                Рейтинг считается без учёта купленных баллов.
            </p>

            {onConfirm && (
                <button
                    name='conditions'
                    className='form__submit'
                    onClick={() => onConfirm()}
                >
                    Согласен
                </button>
            )}
        </InfoTooltip>
    );
};